import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import {
  Hospitalisation,
  Patient,
  AnesthesiologyConsultation,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";

export default function AnesthesiologyConsultationCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: AnesthesiologyConsultation;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: AnesthesiologyConsultation) => void;
}) {
  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={"Consultation d'anesthésie"}
      subTitle={getUserShortName(item?.creator) || ""}
      onEdit={async () => {
        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("anesthesiologyConsultations", "addOne", {
              anesthesiologyConsultation: newItem,
            });
            onChange?.(newItem);
          },
        });
      }}
      onClick={async () => {
        console.log("item", item);

        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("anesthesiologyConsultations", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    ></Card>
  );
}
